import React, { useEffect, useState } from "react";
import axios from "../../axiosConfig";
import "./UserList.css";

const initialFormState = {
  id: null,
  email: "",
  fname: "",
  lname: "",
  is_admin: false,
  is_management: false,
};

const UserList = () => {
  const [showUsers, setShowUsers] = useState(false);
  const [users, setUsers] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    if (showUsers) fetchUsers();
  }, [showUsers]);

  const fetchUsers = async () => {
    try {
      const res = await axios.get("/api/users/", { withCredentials: true });
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch users", err);
    }
  };

  const openAddModal = () => {
    setFormData(initialFormState);
    setModalVisible(true);
  };

  const openEditModal = (user) => {
    console.log("Editing user:", user);
    setFormData({
      id: user.id,
      email: user.email,
      fname: user.fname,
      lname: user.lname,
      is_admin: user.is_admin,
      is_management: user.is_management,
    });
    setModalVisible(true);
  };
  

  const handleDelete = async (id) => {
    try {
      await axios.post("/api/edit/", { id, delete: true }, { withCredentials: true });
      fetchUsers();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const handleSubmit = async () => {
    try {
      console.log("Submitting:", formData); // ← log payload
      await axios.post("/api/edit/", formData, { withCredentials: true });
      setModalVisible(false);
      fetchUsers();
    } catch (err) {
      console.error("Save failed", err);
    }
  };
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  
  return (
    <div className="user-list-container">
      <div className="user-list-header" onClick={() => setShowUsers((prev) => !prev)}>
        <span className="arrow">{showUsers ? "▼" : "▶"}</span>
        <h3>Users</h3>
      </div>

      {showUsers && (
        <>
          <button onClick={openAddModal} className="add-user-btn">Add User</button>
          <table className="user-table">
            <thead>
              <tr>
                <th>First Name</th><th>Last Name</th><th>Email</th>
                <th>Management</th><th>Admin</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.fname}</td>
                  <td>{user.lname}</td>
                  <td>{user.email}</td>
                  <td>{user.is_management ? "✔️" : "❌"}</td>
                  <td>{user.is_admin ? "✔️" : "❌"}</td>
                  <td>
                    <button onClick={() => openEditModal(user)}>Edit</button>
                    <button onClick={() => handleDelete(user.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {modalVisible && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{formData.id ? "Edit User" : "Add User"}</h3>
            <div className="form-group">
              <label>Email</label>
              <input name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>First Name</label>
              <input name="fname" value={formData.fname} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input name="lname" value={formData.lname} onChange={handleChange} />
            </div>
            <div className="form-group checkbox">
              <label>
                <input type="checkbox" name="is_admin" checked={formData.is_admin} onChange={handleChange} />
                Admin
              </label>
              <label>
                <input type="checkbox" name="is_management" checked={formData.is_management} onChange={handleChange} />
                Management
              </label>
            </div>
            <div className="modal-actions">
              <button onClick={handleSubmit}>Confirm</button>
              <button onClick={() => setModalVisible(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserList;
